

const Edit = ({ value, setValue, onClose, onSave }) => {

  const handleChange = (e) => {
    setValue(e.target.value);
  };


  const handleSave = () => {
    onSave(); 
    onClose(); 
  };

  return (
    <div
  className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
  style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", zIndex: 1050 }}
>
  <div className="bg-white rounded p-4 shadow" style={{ minWidth: "400px", maxWidth: "90%" }}>
    <h5 className="mb-3 text-center">Edit Task</h5>
    <input
      type="text"
      className="form-control mb-3"
      value={value}
      onChange={handleChange}
    />
    <div className="d-flex justify-content-end gap-2">
      <button className="btn btn-secondary" onClick={onClose}>
        Cancel
      </button>
      <button className="btn btn-primary" onClick={handleSave}>
        Save
      </button>
    </div>
  </div>
</div>

  );
};

export default Edit;
